
export default {
    name: 'LeeScrollSelect',
    inheritAttrs: false,
    data() {
        return {
            show: false,
            date: {
                year: '',
                month: '',
                day: '',
                hour: '',
                min: '',
                sec: ''
            },
            posy: {
                year: 0,
                month: 0,
                day: 0,
                hour: '',
                min: '',
                sec: ''
            },
            movey: {
                year: 0,
                month: 0,
                day: 0,
                hour: '',
                min: '',
                sec: ''
            },
            oldy: 0,
            isdown: false,
            which: '',
            maxy: 0,
            perh: 35
        }
    },
    mounted() {

    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'date' //默认default
        },
        color: {
            type: String,
            default: '#46bd87' //默认default
        }
    },
    methods: {
        chuli() {
            let senddata = {}
            if (this.type === 'date') {
                senddata = {
                    year: this.date.year,
                    month: this.date.month,
                    day: this.date.day,
                }
            }else if (this.type === 'time') {
                senddata = {
                    hour: this.date.hour,
                    min: this.date.min,
                    sec: this.date.sec,
                }
            }
            this.$emit('change', senddata)
            this.$emit('input', false)
        },
        mousedown(which) {
            this.oldy = event.pageY
            this.isdown = true
            this.which = which
        },
        mousemove() {
            if (this.isdown) {
                this.movey[this.which] = event.pageY - this.oldy
                if(this.posy[this.which]>=0){
                    this.movey[this.which] = (event.pageY - this.oldy)*(1/3)
                }
                if(this.posy[this.which]<= this.maxy){
                    this.movey[this.which] = (event.pageY - this.oldy)*(1/3)
                }
            }
        },
        mouseup() {
            let year = new Date().getFullYear()
            this.isdown = false
            this.movey[this.which] = 0
            this.posy[this.which] += event.pageY - this.oldy
            //临界判断
            if (this.posy[this.which] > 0) {
                this.posy[this.which] = 0
            }
            if (this.posy[this.which] <= this.maxy) {
                this.posy[this.which] = this.maxy
            }
            //转化
            let xh = Math.ceil(Math.abs(this.posy[this.which]) / this.perh)
            this.$set(this.posy, this.which, -xh * this.perh)
            if (this.which === 'year') {
                this.$set(this.date, this.which, year - xh)
            } else {
                this.$set(this.date, this.which, xh + 1)
            }
        },
        mouseleave(){
            let year = new Date().getFullYear()
            this.isdown = false
            this.posy[this.which] += this.movey[this.which]//把mousemove的值传给他
            this.movey[this.which] = 0//movey 重置为0
            //临界判断
            if (this.posy[this.which] > 0) {
                this.posy[this.which] = 0
            }
            if (this.posy[this.which] <= this.maxy) {
                this.posy[this.which] = this.maxy
            }
            //转化
            let xh = Math.ceil(Math.abs(this.posy[this.which]) / this.perh)
            this.$set(this.posy, this.which, -xh * this.perh)
            if (this.which === 'year') {
                this.$set(this.date, this.which, year - xh)
            } else {
                this.$set(this.date, this.which, xh + 1)
            }
        },
        touchstart(which) {
            this.oldy = event.targetTouches[0].pageY
            this.isdown = true
            this.which = which
        },
        touchmove() {
            if (this.isdown) {
                this.movey[this.which] = event.targetTouches[0].pageY - this.oldy
                 if(this.posy[this.which]>=0){
                    this.movey[this.which] = (event.targetTouches[0].pageY - this.oldy)*(1/3)
                }
                if(this.posy[this.which]<= this.maxy){
                    this.movey[this.which] = (event.targetTouches[0].pageY - this.oldy)*(1/3)
                }
            }
        },
        touchend() {
            let year = new Date().getFullYear()
            this.isdown = false
            this.movey[this.which] = 0
            this.posy[this.which] += event.changedTouches[0].pageY - this.oldy
            //临界判断
            if (this.posy[this.which] > 0) {
                this.posy[this.which] = 0
            }
            if (this.posy[this.which] <= this.maxy) {
                this.posy[this.which] = this.maxy
            }
            //转化
            let xh = Math.ceil(Math.abs(this.posy[this.which]) / this.perh)
            this.$set(this.posy, this.which, -xh * this.perh)
            if (this.which === 'year') {
                this.$set(this.date, this.which, year - xh)
            } else {
                this.$set(this.date, this.which, xh + 1)
            }
        }
    },
    watch: {
        which: {
            immediate: true,
            handler(value) {
                if (value === 'year') {
                    this.maxy = -79 * 35
                } else if (value === 'month') {
                    this.maxy = -11 * 35
                } else if (value === 'day') {
                    this.maxy = -30 * 35
                } else if (value === 'hour') {
                    this.maxy = -23 * 35
                } else if (value === 'min') {
                    this.maxy = -59 * 35
                } else if (value === 'sec') {
                    this.maxy = -59 * 35
                }

            }
        },
        value: {
            immediate: true,
            handler(value) {
                this.show = value
            }
        },
        show: {
            immediate: true,
            handler(value) {
                if (value) {
                    let now = new Date()
                    let year = now.getFullYear()
                    let month = now.getMonth() + 1
                    let day = now.getDate()
                    let hour = now.getHours()
                    let min = now.getMinutes()
                    let sec = now.getSeconds()
                    this.$set(this.date, 'year', year)
                    this.$set(this.date, 'month', month)
                    this.$set(this.date, 'day', day)
                    this.$set(this.date, 'hour', hour)
                    this.$set(this.date, 'min', min)
                    this.$set(this.date, 'sec', sec)
                    this.$set(this.posy, 'year', 0)
                    this.$set(this.posy, 'month', -(month - 1) * this.perh)
                    this.$set(this.posy, 'day', -(day - 1) * this.perh)
                    this.$set(this.posy, 'hour', -(hour - 1) * this.perh)
                    this.$set(this.posy, 'min', -(min - 1) * this.perh)
                    this.$set(this.posy, 'sec', -(sec - 1) * this.perh)

                } else {
                    //document.body.style.cssText = ""
                }
            }
        }
    },
    computed: {
        year: function () {
            let years = []
            let date = new Date().getFullYear()
            for (let i = 0; i < 80; i++) {
                years.push(date)
                date -= 1;
            }
            return years
        }
    }
};
